const BrandStatement = () => {
  return (
    <section className="bg-jp-pearl py-32 md:py-48 border-t border-jp-dust/20">
      <div className="container mx-auto px-6 text-center max-w-4xl space-y-8">
        <h2 className="font-serif italic text-3xl md:text-5xl text-jp-deep font-bold leading-normal">
          "Flowers die in three days. We make things that last."
        </h2>
        <p className="font-sans text-sm text-jp-charcoal/80 max-w-2xl mx-auto leading-relaxed font-medium">
          Every JewelPetal bouquet contains real wearable jewelry and fashion accessories — curated, styled, and gift-wrapped to perfectly celebrate the women in your life.
        </p>
        <div className="w-16 h-[1px] bg-jp-rosegold/50 mx-auto" />
      </div>
    </section>
  );
};

export default BrandStatement;
